import React from "react";

export default function DonorWall({ donors }) {
  if (!donors.length) {
    return (
      <p className="text-center text-navy/40 py-8 text-sm">
        Be the first to donate!
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {donors.map((d) => (
        <div
          key={d.id}
          className="bg-white rounded-lg border border-warm-gray p-4 flex items-start gap-3"
        >
          <div className="w-9 h-9 rounded-full bg-navy/10 flex items-center justify-center shrink-0 mt-0.5">
            <span className="text-navy/60 text-xs font-bold">
              {d.anonymous ? "?" : d.name.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-baseline justify-between gap-2">
              <span className="font-semibold text-sm text-navy truncate">
                {d.anonymous ? "Anonymous" : d.name}
              </span>
              <span className="text-xs text-navy/40 whitespace-nowrap">
                ${d.amount}
              </span>
            </div>
            {d.message && (
              <div className="flex gap-1.5 mt-1.5">
                <svg className="w-3 h-3 text-navy/20 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
                </svg>
                <p className="text-sm text-navy/60 leading-relaxed italic">
                  {d.message}
                </p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
